import Vue from "vue";
import Router from "vue-router";
import store from "@/store";

// ===== ROUTE IMPORTS =====
import AuthRoutes from "./routes/auth";
import DashboardRoutes from "./routes/dashboard";

Vue.use(Router);

export function ifNotAuthenticated(to, from, next) {
    if (!store.state.auth.access_token) {
        next();
        return;
    }

    next("/");
};

export function ifAuthenticated (to, from, next) {
    if (store.state.auth.access_token) {
        next();
        return;
    }

    next("/login");
};

export default new Router({
    mode: "history",
    routes: [
        ...AuthRoutes,
        ...DashboardRoutes,
    ],
});
